<script setup>
import UmisisModal from '../../../../../../../resources/js/components/umisis/generic/UmisisModal.vue'
import { useModalControl } from '../../../../../../../resources/js/composables/modal/useUmisisModal.js'
const { componentRef: dialog, openModal, closeModal } = useModalControl()
import { ref } from 'vue'
import { useApiAction } from '@/composables/dispatchers/useApiAction.js'
import { useUserManagerStore } from '../../stores/userManagerStore.js'
import { toast }  from 'vue-sonner'
import { useI18n } from 'vue-i18n'
import { useUserRoleStore } from '../../stores/userRoleStore.js'
import InputTagsWithPredefined from '../../../../../../../resources/js/components/umisis/form/inputs/InputTagsWithPredefined.vue'
const { t } = useI18n()

defineExpose({
  openModal,
  closeModal
})

const props = defineProps({
  user: {
    type: Object,
    required: true
  }
})

const userRoles = ref([])

const onShow = () => {
  // Populate fields when modal is shown
  useUserRoleStore().fetchItems()
  userRoles.value = props.user.roles || []

}

const { execute, loading, getError, validationResult } = useApiAction((payload) => {
  if(props.user) {
    // we need to patch
    return useUserManagerStore().setRolesForUser(props.user.id, payload)
  } else {

  }
},
{
  onSuccess: () => {
    toast.success(t('userManager.notifications.userRolesUpdated'))
    closeModal()
  }
})

const handleOk = async (bvEvent) => {
  bvEvent? bvEvent.preventDefault() : null
  // 2. Just pass the payload, the wrapper handles the rest
  await execute({
    roles_ids: userRoles.value.map(role => role.id)
  })
}

</script>

<template>
  <UmisisModal ref="dialog" :ok-disabled="loading" :title="$t('userManager.actions.editUserRoles')" @ok="handleOk" @show="onShow">
    <div class="flex flex-col gap-4">
      <InputTagsWithPredefined v-model="userRoles" :options="useUserRoleStore().items" label="Roles" item-label="name" item-id="id" />
    </div>
  </UmisisModal>
</template>

<style scoped>

</style>
